import { dateFormatter, integerFormatter, numberFormatter } from "../../gridFormatters";

export const virtualTrends = [
	{
		"field": "collection_date",
		"headerName": "Date",
		"cellRenderer": dateFormatter,
	},
	{ headerName: 'CPU Used', field: 'cpu_used', "type": "numericColumn", "cellRenderer": numberFormatter, },
	{ headerName: 'CPU Capacity', field: 'cpu_capacity', "type": "numericColumn", "cellRenderer": numberFormatter },
	{ headerName: 'Memory Used (GiB)', field: 'memory_used', "type": "numericColumn", "cellRenderer": numberFormatter },
	{ headerName: 'Memory Capacity (GiB)', field: 'memory', "type": "numericColumn", "cellRenderer": numberFormatter },
	{ headerName: 'Disk Used (GiB)', field: 'disk_used', "type": "numericColumn", "cellRenderer": numberFormatter },
	{ headerName: 'Disk Capacity (GiB)', field: 'disk_capacity', "type": "numericColumn", "cellRenderer": numberFormatter },
	{ headerName: '# of VMs', field: 'num_vms', "type": "numericColumn", "cellRenderer": integerFormatter },
	{ headerName: 'VM Build Capacity', field: 'vm_build_capacity', "type": "numericColumn", "cellRenderer": integerFormatter },
]